const EXIT_NODE_LIVE_WINDOW_MS = 90_000;

export function isExitNodeConnected(lastSeenAt: number, now: number): boolean {
  return now - lastSeenAt < EXIT_NODE_LIVE_WINDOW_MS;
}
